module.exports = __webpack_public_path__ + "img/bannertop.100f2b51.jpg";